module.exports = __webpack_public_path__ + "static/media/task.a0c09ef9.svg";